// Sprint 15 — paginated history hook for the chat conversation list.
//
// Thin wrapper around the store's `loadOlderMessages` action. Surfaces the
// same { loadingOlder, hasMore } state the store tracks per agent, plus a
// stable `loadOlder` callback the virtualized list can pass to Virtuoso's
// `startReached`. Single in-flight is enforced inside the store action;
// the hook does not need its own concurrency guard.

import { useCallback } from 'react';
import { useAppStore } from '../stores/app.store';

export interface PaginatedHistoryState {
  loadingOlder: boolean;
  hasMore: boolean;
  loadOlder: () => Promise<void>;
}

export function usePaginatedHistory(agentId: string | null): PaginatedHistoryState {
  const history = useAppStore((s) =>
    agentId ? s.historyByAgent[agentId] : undefined,
  );

  const loadOlder = useCallback(async () => {
    if (!agentId) return;
    await useAppStore.getState().loadOlderMessages(agentId);
  }, [agentId]);

  return {
    loadingOlder: history?.loadingOlder ?? false,
    hasMore: history?.hasMore ?? false,
    loadOlder,
  };
}
